/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Manager_Terms_TabInputs */

const en_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terms (${i?.count})`)
};

const fr_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termes (${i?.count})`)
};

const de_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begriffe (${i?.count})`)
};

const it_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termini (${i?.count})`)
};

const ru_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Термины (${i?.count})`)
};

const es_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Términos (${i?.count})`)
};

const zh_cn2_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`条款（${i?.count}）`)
};

const ja_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`利用規約 (${i?.count})`)
};

const hi_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शर्तें (${i?.count})`)
};

const pt_pt2_knp_manager_terms_tab = /** @type {(inputs: Knp_Manager_Terms_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termos (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Terms ({count})" |
*
* @param {Knp_Manager_Terms_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_terms_tab = /** @type {((inputs: Knp_Manager_Terms_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Terms_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_terms_tab(inputs)
	if (locale === "de") return de_knp_manager_terms_tab(inputs)
	if (locale === "it") return it_knp_manager_terms_tab(inputs)
	if (locale === "ru") return ru_knp_manager_terms_tab(inputs)
	if (locale === "es") return es_knp_manager_terms_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_terms_tab(inputs)
	if (locale === "ja") return ja_knp_manager_terms_tab(inputs)
	if (locale === "hi") return hi_knp_manager_terms_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_terms_tab(inputs)
	return en_knp_manager_terms_tab(inputs)
});